module.exports = __webpack_public_path__ + "img/ico-cash.5ce8b806.svg";